// eslint-disable-next-line import/no-extraneous-dependencies
import { jwtDecode } from 'jwt-decode';
import { message } from 'antd';

interface DecodedToken {
  exp: number;
  [key: string]: any;
}

const validateToken = (token: string): boolean => {
  try {
    const decoded: DecodedToken = jwtDecode<DecodedToken>(token);
    const currentTime = Date.now() / 1000;

    // Check if the token is expired
    if (decoded.exp < currentTime) {
      return false;
    }
    return true;
  } catch (error) {
    message.error(`Invalid token:', ${error}`);
    return false;
  }
};

export default validateToken;
